import React from "react"
import styled from "styled-components"

const Wrapper = styled.div`
  padding: 50px 0;
`

const PaddingWrapper = (props) => <Wrapper>{props.children}</Wrapper>

export default PaddingWrapper
